import React, { ReactElement, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { ItemType } from '../../types/common.types';
import { CustomTab } from '../shared/tab/tab';
import { Header } from '../shared/header/header';
import { MaterialRoutine } from './materialRoutine';
import { MaterialIntegrityQuickGuide } from './materialIntegrityQuickGuide';
import { VerificationRoutine } from './verificationRoutine';

export const RuleEngine = (): ReactElement => {
	const classes = useStyles();
	const tabs: ItemType[] = [
		{
			key: 0,
			value: 'Material Routine',
		},
		{
			key: 1,
			value: 'Verification Routine',
		},
		/*{
			key: 2,
			value: 'Material Integrity Quick Guide',
		},*/
	];

	const [activeTab, setActiveTab] = useState<number>(0);

	return (
		<>
			<Header title="Material Integrity Requirements" />
			<div className={classes.topPadding}>
				<CustomTab data={tabs} value={activeTab} onChangeCallback={setActiveTab} />
			</div>
			{activeTab === 0 && <MaterialRoutine />}
			{activeTab === 1 && <VerificationRoutine />}
			{activeTab === 2 && <MaterialIntegrityQuickGuide />}
		</>
	);
};

const useStyles = makeStyles(() => ({
	topPadding: {
		paddingTop: '15px'
	},
}));
